/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-var-requires */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { createRoot as originalCreateRoot } from 'react-dom/client';

import React, { ComponentType } from 'react';
import getAppContainerId from '../dom/getAppContainerId';

const render = <T extends object>(App: ComponentType<T>, props?: T) => {
  const createRoot = getCreateRoot();
  const appNode = document.getElementById(getAppContainerId());
  const root = createRoot(appNode);
  root.render(<App {...props} />);
};

const getCreateRoot = (): typeof originalCreateRoot => {
  /* istanbul ignore next */
  let ret = () => { /* */ };
  try {
    const { createRoot } = require('react-dom/client');
    ret = createRoot;
  } finally {
    // nothing
  }
  return ret as unknown as typeof originalCreateRoot;
};

export default render;
